<template>
  <vue-scroll
    ref="searchResultsScroll"
    class="toc-items-scroll"
    :ops="{
      scrollPanel: { scrollingX: false },
      bar: { size: '6px', keepShow: false },
    }"
  >
    <div
      class="toc-items-parent"
      :class="{
        'not-small-screen': !smallScreenView,
      }"
    >
      <a
        v-for="item in items"
        :key="item.id"
        class="toc-item"
        :class="[
          { [`pl-${item.originalLevel * 2}`]: item.originalLevel > highestLevel },
          { 'bg-activeItem-default highlight-toc-item text-text-default': item.isActive },
          { 'font-medium': highlightLevel(item.originalLevel) },
        ]"
        :href="`#${item.id}`"
        @click.prevent="onItemClick(item)"
      >
        {{ item.dom.innerText }}
      </a>
    </div>
  </vue-scroll>
</template>

<script>
export default {
  name: 'TableOfContentItems',

  props: {
    items: {
      type: Array,
      required: false,
      default: () => [],
    },
    expanded: {
      type: Boolean,
      required: false,
      default: true,
    },
    editorId: {
      type: String,
      required: false,
      default: '',
    },
    smallScreenView: {
      type: Boolean,
      required: false,
      default: false,
    },

    editorProp: {
      type: Object,
      required: false,
      default: null,
    },
  },

  emits: ['scrollTo'],

  data() {
    return {
      highestLevel: 0,
    };
  },

  computed: {
    editor() {
      return this.editorProp ?? this.$store.getters.editor(this.editorId);
    },
  },

  watch: {
    items() {
      this.getHighestLevel();
    },
  },
  beforeMount() {
    this.getHighestLevel();
  },

  methods: {
    onItemClick(item) {
      this.editor.storage.tableOfContent.content.forEach((i, index) => {
        i.isActive = false;
        if (item.id === i.id) {
          this.$emit('scrollTo', item.id);
          this.editor.storage.tableOfContent.content[index].isActive = true;
          this.aminateLocationItem(item.dom);
        }
      });
    },

    aminateLocationItem(element) {
      element.animate(
        [
          { backgroundColor: 'transparent' },
          { backgroundColor: '#7daeff' },
          { backgroundColor: 'transparent' },
        ],
        {
          duration: 800,
          eassing: 'ease-in-out',
        }
      );
    },

    getHighestLevel() {
      if (this.items.length === 0) {
        return null; // Return null for an empty array
      }

      // Using reduce to find the item with the highest level
      const highestLevelItem = this.items.reduce((min, current) =>
        current.originalLevel < min.originalLevel ? current : min
      );
      this.highestLevel = highestLevelItem.originalLevel;
      return highestLevelItem.originalLevel;
    },

    highlightLevel(currentLevel) {
      return currentLevel === this.highestLevel;
    },
  },
};
</script>

<style lang="scss">
.toc-items-scroll {
  @apply box-border flex flex-col w-full overflow-y-hidden bg-background-strongest;
  .toc-items-parent {
    @apply flex flex-col border-0;

    &.not-small-screen {
      @apply pl-4 border-l border-solid border-dividers-default;
    }
  }
  .toc-item {
    @apply pl-2 pr-2 mb-1 last:mb-0 text-sm text-text-default rounded hover:bg-activeItem-default no-underline truncate;
  }
  &.mouseEnter {
    &.__vuescroll {
      .__bar-is-vertical {
        opacity: 1 !important;
      }
    }
  }

  .__rail-is-vertical {
    padding-left: 15px;
  }
}
</style>
